import { RootState } from "core-integration/src/store";
import { getElement } from "core-integration/src/store/elements/reducers";
import { getFixturesStatusForTeamInEvent } from "core-integration/src/store/fixtures/reducers";
import { useSelector } from "react-redux";
import { ElementPointsProps } from "../../ElementPoints/types";
import ElementCardFixtures from "../ElementCardFixtures";
import ElementCardPoints from "../ElementCardPoints";

const ValueForPlayedElement = ({ eventId, pick }: ElementPointsProps) => {
  const element = useSelector((state: RootState) =>
    getElement(state, pick.element),
  );
  const fixturesStatus = useSelector((state: RootState) =>
    getFixturesStatusForTeamInEvent(state, eventId, element.team),
  );

  if (fixturesStatus.hasStarted) {
    return <ElementCardPoints eventId={eventId} pick={pick} />;
  }

  return <ElementCardFixtures elementId={pick.element} eventId={eventId} />;
};

export default ValueForPlayedElement;
